import React, { Component } from "react"
import { connect } from "react-redux"
import MultipleProduct from "../../components/MultipleProduct"
import MultipleProductDetail from "../../components/MultipleProductDetail"

const INITIAL_STATE = {
    page: "",
    productId: 0,
}

function mapStateToProps(state) {
    return {
        pages: state.pages,
    }
}

class MultipleProductPage extends Component {
    constructor(props) {
        super(props)
        this.state = Object.assign({}, INITIAL_STATE)
    }

    render() {
        const { page, productId } = this.state
        switch (page) {
            case "MultipleProduct":
                return (
                    <MultipleProduct
                        redirectToPage={(value, productId) => {
                            this.setState({ page: value, productId: productId })
                        }}
                    />
                )

            case "MultipleProductDetail":
                return (
                    <MultipleProductDetail
                        productId={productId}
                        redirectToPage={(value) => {
                            this.setState({ page: value })
                        }}
                    />
                )
            default:
                return (
                    <MultipleProduct
                        redirectToPage={(value, productId) => {
                            this.setState({ page: value, productId: productId })
                        }}
                    />
                )
        }
    }
}

export default connect(mapStateToProps, null)(MultipleProductPage)
